"use client";

import { Mail } from "lucide-react";
import { Button } from "@/components/shadcn/button";
import { motion } from "framer-motion";

interface IntroStepProps {
  onNext: () => void;
  onSkip: () => void;
}

export const IntroStep = ({ onNext, onSkip }: IntroStepProps) => {
  return (
    <div className="flex flex-col items-center flex-1 text-center w-full">
      <div className="flex-1 flex flex-col items-center justify-center space-y-8 max-w-xs">
        <motion.div
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{
            duration: 0.6,
            delay: 0.1,
            ease: [0.22, 1, 0.36, 1],
          }}
          className="w-10 h-10 rounded-lg bg-accent flex items-center justify-center"
        >
          <Mail size={24} strokeWidth={2} />
        </motion.div>

        <div className="space-y-2">
          <motion.h2
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{
              delay: 0.2,
              duration: 0.5,
            }}
            className="text-lg font-medium"
          >
            What is an agentic inbox?
          </motion.h2>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{
              delay: 0.35,
              duration: 0.5,
            }}
            className="text-sm text-muted-foreground leading-relaxed"
          >
            A unified command center where your team collaborates directly with
            AI Agents.
          </motion.p>
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.4 }}
        >
          <Button onClick={onNext} className="w-52 h-8">
            See how it works
          </Button>
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.7, duration: 0.4 }}
      >
        <Button
          onClick={onSkip}
          variant="ghost"
          className="text-sm font-medium text-ring hover:text-muted-foreground transition-colors"
        >
          Skip & Create
        </Button>
      </motion.div>
    </div>
  );
};
